import {defaultPreset} from "../../components/settings/presets"

export default function BusFavicon() {
    const PRIMARY_COLOR = defaultPreset.main

    const pathSVG = '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="{{primaryColor}}">' +
        '<path d="M0 0h24v24H0V0z" fill="none"/>' +
        '<path d="M4 16c0 .88.39 1.67 1 2.22V21h3v-2h8v2h3v-2.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"/></svg>'

    const header = 'data:image/svg+xml,'
    const svgColorized = pathSVG
        .replace("{{primaryColor}}", PRIMARY_COLOR)

    return header + encodeURIComponent(svgColorized)
}